<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("storemanagement") }}</div>
        <div class="section-subTitle my-2"></div>
      </div>
      <div class="mr-3">
        <b-button
          to="add-store-management"
          variant="default"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="white-wrapper mt-4">
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  href="#"
                  @click="onSelectCinema(dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-6 text-right">
          <b-button variant="default" class="btn-blue">{{ $tc('edit') }}</b-button>
        </div>-->
      </div>

      <div class="branching d-flex justify-content-center">
        <nav class="nav">
          <ul>
            <li
              v-if="
                Object.keys(StoreDetails).length > 0 &&
                  StoreDetails[1][0].hasOwnProperty('children') &&
                  StoreDetails[1][0].children.length > 0
              "
            >
              <!-- Level 1 -->
              <div class="fc-box">
                <div class="d-flex justify-content-center align-items-center">
                  <div>Level 1</div>
                  <div class="ml-2">
                    <router-link
                      to
                      @click.prevent.native="
                        goToRoute(StoreDetails[1][0].sm_id)
                      "
                    >
                      <span class="edit-fc-pen"></span>
                    </router-link>
                  </div>
                </div>
                <div>{{ StoreDetails[1][0].sm_store_name }}</div>
              </div>
              <!-- Level 1 Ends -->
              <!-- Level 2 -->
              <ul>
                <li
                  v-for="(level, singleLevelIndex) in StoreDetails[1][0]
                    .children"
                  :key="singleLevelIndex"
                >
                  <div class="fc-box">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <div>Level 2</div>
                      <div class="ml-2">
                        <router-link
                          to
                          @click.prevent.native="goToRoute(level.sm_id)"
                        >
                          <span class="edit-fc-pen"></span>
                        </router-link>
                      </div>
                    </div>
                    <div>{{ level.sm_store_name }}</div>
                  </div>
                  <ul>
                    <!-- LEVLE 3 -->
                    <li
                      v-for="(singleChild, singleChildIndex) in level.children"
                      :key="singleChildIndex"
                    >
                      <div class="fc-box">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div>Level 3</div>
                          <div class="ml-2">
                            <router-link
                              to
                              @click.prevent.native="
                                goToRoute(singleChild.sm_id)
                              "
                            >
                              <span class="edit-fc-pen"></span>
                            </router-link>
                          </div>
                        </div>
                        <div>{{ singleChild.sm_store_name }}</div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li
              v-else-if="Object.keys(StoreDetails).length > 0"
              v-for="(level, singleLevelIndex) in StoreDetails[1]"
              :key="singleLevelIndex"
            >
              <!-- Level 1 -->
              <div class="fc-box">
                <div class="d-flex justify-content-center align-items-center">
                  <div>Level 1</div>
                  <div class="ml-2">
                    <router-link
                      to
                      @click.prevent.native="goToRoute(level.sm_id)"
                    >
                      <span class="edit-fc-pen"></span>
                    </router-link>
                  </div>
                </div>
                <div>{{ level.sm_store_name }}</div>
              </div>
              <ul>
                <!-- LEVLE 3 -->
                <li
                  v-for="(singleChild, singleChildIndex) in level.children"
                  :key="singleChildIndex"
                >
                  <div class="fc-box">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <div>Level 2</div>
                      <div class="ml-2">
                        <router-link
                          to
                          @click.prevent.native="goToRoute(singleChild.sm_id)"
                        >
                          <span class="edit-fc-pen"></span>
                        </router-link>
                      </div>
                    </div>
                    <div>{{ singleChild.sm_store_name }}</div>
                  </div>
                </li>
              </ul>
              <!-- Level 1 Ends -->
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import { groupBy } from "lodash";

export default {
  name: "StoreManagement",
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      isRoleID: true,
      Cinemas: [],
      StoreDetails: [],
      levelDetails: [],
      selectedCinema: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.isRoleID1 = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemas(obj);
    } else {
      this.getCinemas(obj);
    }

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.getStoreMap(CinemaObj.cine_id);
    }
  },
  methods: {
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemas: function(cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema({
                  cine_name: x.cine_name,
                  cine_id: x.cine_id
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function(params) {
      this.selectedCinema = params.cine_name;
      this.searchCinema = "";
      this.onSearchCinema();
      this.getStoreMap(params.cine_id);
      this.$store.dispatch("selectDropdownCinema", params);
    },
    goToRoute: function(sm_id) {
      this.$router.push({
        path: "/fnb/edit-store-management",
        query: { sm_id: sm_id }
      });
    },
    getStoreMap: function(cinema_id) {
      this.StoreDetails = [];
      let payload = {
        cinema_id: cinema_id
      };
      PosFnbService.GetStoreManagementDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.StoreDetails = data.Records;
              var buildTree = function(tree, item) {
                // console.log("tree :", tree);
                if (item) {
                  // if item then have parent
                  for (var i = 0; i < tree.length; i++) {
                    // parses the entire tree in order to find the parent
                    if (String(tree[i].sm_id) === String(item.sm_parent_id)) {
                      // bingo!
                      tree[i].children.push(item); // add the child to his parent
                      break;
                    } else buildTree(tree[i].children, item); // if item doesn't match but tree have childs then parses childs again to find item parent
                  }
                } else {
                  // if no item then is a root item, multiple root items are supported
                  var idx = 0;
                  while (idx < tree.length)
                    if (tree[idx].sm_parent_id > 0)
                      buildTree(tree, tree.splice(idx, 1)[0]);
                    // if have parent then remove it from the array to relocate it to the right place
                    else idx++; // if doesn't have parent then is root and move it to the next object
                }
              };
              for (var i = 0; i < this.StoreDetails.length; i++) {
                // add childs to every item
                this.StoreDetails[i].children = [];
              }
              buildTree(this.StoreDetails);
              this.StoreDetails = groupBy(this.StoreDetails, "sm_order");
              Object.keys(this.StoreDetails).map(s => {
                this.levelDetails.push(this.StoreDetails[s]);
              });
              console.log("this.StoreDetails :", this.StoreDetails);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StoreManagementComponents/storeManagement.vue